module.exports = __webpack_public_path__ + "static/media/Gilroy-Bold-Italic.f1ac0c35.woff";